module.exports = __webpack_public_path__ + "static/media/Logo-01.52d89935.png";